import React from "react";
import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
import { BusinessesLoadingDialog } from "./businesses-loading-dialog/BusinessesLoadingDialog";
import { BusinessesCard } from "./BusinessesCard";
import { BusinessesUIProvider } from "./BusinessesUIContext";
import { BusinessDeleteDialog } from "./business-delete-dialog/BusinessDeleteDialog";
import { BusinessesDeleteDialog } from "./businesses-delete-dialog/BusinessesDeleteDialog";
import { BusinessesFetchDialog } from "./businesses-fetch-dialog/BusinessesFetchDialog";
import { BusinessesUpdateStatusDialog } from "./businesses-update-status-dialog/BusinessesUpdateStatusDialog";

function BusinessesDeleteDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <BusinessesDeleteDialog show={location.pathname === "/business/reported/deleteBusinesses"} onHide={() => navigate("/business/reported")} />;
}
function BusinessDeleteDialogRoute() {
  const navigate = useNavigate();
  const { id } = useParams();
  return <BusinessDeleteDialog show id={id} onHide={() => navigate("/business/reported")} />;
}
function BusinessesFetchDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <BusinessesFetchDialog show={location.pathname === "/business/reported/fetch"} onHide={() => navigate("/business/reported")} />;
}
function BusinessesUpdateStatusDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <BusinessesUpdateStatusDialog show={location.pathname === "/business/reported/updateStatus"} onHide={() => navigate("/business/reported")} />;
}

export function BusinessesPageReported() {
  const navigate = useNavigate();
  const businessesUIEvents = {
    newBusinessButtonClick: () => navigate("/business/new"),
    openEditBusinessPage: (id) => navigate(`/business/${id}/edit`),
    openDeleteBusinessDialog: (id) => navigate(`/business/reported/${id}/delete`),
    openDeleteBusinessesDialog: () => navigate("/business/reported/deleteBusinesses"),
    openFetchBusinessesDialog: () => navigate("/business/reported/fetch"),
    openUpdateBusinessesStatusDialog: () => navigate("/business/reported/updateStatus"),
  };

  return (
    <BusinessesUIProvider businessesUIEvents={businessesUIEvents}>
      <BusinessesLoadingDialog />
      <Routes>
        <Route path="deleteBusinesses" element={<BusinessesDeleteDialogRoute />} />
        <Route path=":id/delete" element={<BusinessDeleteDialogRoute />} />
        <Route path="fetch" element={<BusinessesFetchDialogRoute />} />
        <Route path="updateStatus" element={<BusinessesUpdateStatusDialogRoute />} />
      </Routes>
      <BusinessesCard />
    </BusinessesUIProvider>
  );
}
